function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M-2-2h20v20H-2z"
}), React.createElement("path", {
  d: "M13.833.5H2.167C1.25.5.5 1.25.5 2.167v11.666c0 .917.75 1.667 1.667 1.667h11.666c.917 0 1.667-.75 1.667-1.667V2.167C15.5 1.25 14.75.5 13.833.5zM2.167 13.833V2.167h5v11.666h-5zm11.666 0h-5V8h5v5.833zm0-7.5h-5V2.167h5v4.166z",
  fill: "currentColor"
}));

var SvgIconDashboard = function SvgIconDashboard(props) {
  return React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 16 16"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/icon-dashboard.a711e7fd.svg";
export { SvgIconDashboard as ReactComponent };